import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { FaSpinner } from 'react-icons/fa';
import { Link } from 'react-router-dom'; // Import Link
import fetchUsernameWithUID from "../functions/fetchUsernameWithUID";

const UserFeed = ({ userid }) => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [username, setUsername] = useState(null);

    useEffect(() => {
        const fetchUsername = async () => {
            try {
                setUsername(await fetchUsernameWithUID(userid));
                setLoading(false);
            } catch (error) {
                console.error('Error fetching username:', error);
                setLoading(false);
            }
        };
        const fetchPosts = async () => {
            try {
                const postsRef = collection(db, 'posts');
                const postsQuery = query(postsRef, where('uid', '==', userid));
                const querySnapshot = await getDocs(postsQuery);

                const postsData = querySnapshot.docs.map(doc => ({
                    id: doc.id,
                    ...doc.data()
                }));

                setPosts(postsData);
            } catch (error) {
                console.error('Error fetching posts:', error);
            }
        } 

        fetchUsername();
        fetchPosts();
    }, [userid]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-96">
                <FaSpinner className="animate-spin h-10 w-10 text-gray-500" />
            </div>
        );
    }

    return (
        <div className="flex flex-col gap-2 w-full p-2">
            {posts.length > 0 ?(
            <>
                {posts.map(post => (
                <Link key={post.id} to={`/post/${post.id}`}>
                    {/* Render the post content */}
                    <div className='border w-full' dangerouslySetInnerHTML={{ __html: post.text }}></div>
                </Link>
            ))}
            </>
            ):(
                <>
                <div>No Posts made yet!</div>
                </>
            )}
            
        </div>
    );
}

UserFeed.propTypes = {
    uid: PropTypes.string.isRequired,
};

export default UserFeed;
